import showModalComponent from './showModal.vue';
import store from '../../store';
export default {
  // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
  install: function(Vue) {
    if (Vue) {
      let SHOWMODAL = Vue.extend({ ...showModalComponent, store });
      const createEl = () => {
        return new SHOWMODAL({
          el: document.createElement('div')
        });
      };

      let showModal = {
        list: [], // 弹窗数组
        /** 
                 * 显示弹窗
                 * @param {Object} config 配置对象
                 */
        show(config) {
          let instance = createEl();
          instance.showModal = true;                    
          Object.assign(instance, config || {});
          document.body.appendChild(instance.$el);
          this.list.push(instance);
        },

        /** 
                 * 关闭弹窗
                 */
        hide() {
          if (this.list[this.list.length - 1]) {
            this.list[this.list.length - 1]['showModal'] = false;
            this.list.pop();
            // if (this.list.length === 0) {
            //     this.closeAll();
            // }
          }
        },

        /** 
                 * 关闭所有弹窗
                 */
        closeAll() {
          let el = document.getElementsByClassName('x-show-modal');
          while (el[0]) {
            el[0].parentNode.removeChild(el[0]);
          }
        }
      };
      Vue.prototype.$showModal = showModal;
      return showModal;
    }
  }
};